import { useGetSectionDataQuery } from 'API/order/fees/FeeApi';
import { ILineItemProps } from './ILineItemProps';
import { useMemo } from 'react';

export const useGetCurrentSection = ({ orderId, sectionDefinitionId }: ILineItemProps) => {
  const { data, isLoading, error } = useGetSectionDataQuery(orderId, { skip: !orderId });

  const currentSection = useMemo(
    () => data?.find((t) => t.statementSectionDefinitionId === sectionDefinitionId),
    [data, sectionDefinitionId]
  );

  return { currentSection, isLoading, error };
};
